// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 21,
  argument: "Cautions against sin in general, and some sins in particular.",
  verses: [
    { n: 1, text: "My son, hast thou sinned? do so no more: but for thy former sins also pray that they may be forgiven thee." },
    { n: 2, text: "Flee from sins as from the face of a serpent: for if thou comest near them, they will take hold of thee." },
    { n: 3, text: "The teeth thereof are the teeth of a lion, killing the souls of men." },
    { n: 4, text: "All iniquity is like a two-edged sword, there is no remedy for the wound thereof." },
    { n: 5, text: "Injuries and wrongs will waste riches: and the house that is very rich shall be brought to nothing by pride: so the substance of the proud shall be rooted out." },
    { n: 6, text: "The prayer out of the mouth of the poor shall reach the ears of God, and judgment shall come for him speedily." },
    { n: 7, text: "He that hateth to be reproved walketh in the trace of a sinner: and he that feareth God will turn to his own heart." },
    { n: 8, text: "He that is mighty by a bold tongue is known afar off, but a wise man knoweth to slip by him." },
    { n: 9, text: "He that buildeth his house at other men's charges, is as he that gathereth himself stones to build in the winter." },
    { n: 10, text: "The congregation of sinners is like tow heaped together, and the end of them is a flame of fire." },
    { n: 11, text: "The way of sinners is made plain with stones, and in their end is hell, and darkness, and pains." },
    { n: 12, text: "He that keepeth justice shall get the understanding thereof." },
    { n: 13, text: "The perfection of the fear of God is wisdom and understanding." },
    { n: 14, text: "He that is not wise in good, will not be taught." },
    { n: 15, text: "But there is a wisdom that aboundeth in evil: and there is no understanding where there is bitterness." },
    { n: 16, text: "The knowledge of a wise man shall abound like a flood, and his counsel continueth like a fountain of life." },
    { n: 17, text: "The heart of a fool is like a broken vessel, and no wisdom at all shall it hold." },
    { n: 18, text: "A man of sense will praise every wise word he shall hear, and will apply it to himself: the luxurious man hath heard it, and it shall displease him, and he will cast it behind his back." },
    { n: 19, text: "The talking of a fool is like a burden in the way: but in the lips of the wise grace shall be found." },
    { n: 20, text: "The mouth of the prudent is sought after in the church, and they will think upon his words in their hearts." },
    { n: 21, text: "As a house that is destroyed, so is wisdom to a fool: and the knowledge of the unwise is as words without sense." },
    { n: 22, text: "Doctrine to a fool is as fetters on the feet, and like manacles on the right hand." },
    { n: 23, text: "A fool lifteth up his voice in laughter: but a wise man will scarce laugh low to himself." },
    { n: 24, text: "Learning to the prudent is as an ornament of gold, and like a bracelet upon his right arm." },
    { n: 25, text: "The foot of a fool is soon in his neighbour's house: but a man of experience will be abashed at the person of the mighty." },
    { n: 26, text: "A fool will peep through the window into the house: but he that is well taught, will stand without." },
    { n: 27, text: "It is the folly of a man to hearken at the door: and a wise man will be grieved with the disgrace." },
    { n: 28, text: "The lips of the unwise will be telling foolish things: but the words of the wise shall be weighed in a balance." },
    { n: 29, text: "The heart of fools is in their mouth: and the mouth of wise men is in their heart." },
    { n: 30, text: "While the ungodly curseth the devil, he curseth his own soul." },
    { n: 31, text: "The tale-bearer shall defile his own soul, and shall be hated by all: and he that shall abide with him shall be hateful: the silent and wise man shall be honoured." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Thee. The just may offend: but the wicked relapse continually.", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "Hold. Greek, \"bite,\" (Calmet) in the same sense. (Menochius) — Serpents sting in secret: so all sins inveigle the soul.", attribution: "Worthington" }
    ] },
    { verse: 3, notes: [
      { text: "Lion. Yet only those are hurt, who consent to sin. The devil may go round about, (1 Peter v. 8.) and tempt; (Calmet) he cannot bite, except a man willingly expose himself, and come near,", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "Remedy. In man. (Haydock) — Only the sovereign physician can cure it.", attribution: "Calmet" }
    ] },
    { verse: 5, notes: [
      { text: "Riches. As they make enemies arise. Greek subjoins, \"so the house of the proud shall be made desolate.\" (Haydock) — Roboam lost ten tribes by an insolent answer, and the Tarquins were expelled for their pride.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Speedily. God is the protector of the poor, Psalm x. 5.", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "Sinner. He rejects all medicines. How shall he be cured? (Calmet) — They who fear God, will examine their actions when they are warned.", attribution: "Worthington" }
    ] },
    { verse: 8, notes: [
      { text: "By him. And to avoid his reproaches. Greek, \"knoweth when he is ruined.\" (Haydock) — He is more reserved, and escapes the dangers of talkativeness.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Winter. This season is unfit for building; so the man who borrows, may be forced to pay again (Calmet) before it is convenient for him. (Haydock) — Injustice will bring on ruin, Jeremias xxiii. 13. Some Greek copies have, \"stones for a heap over his tomb,\" as Achan and Absalom were treated. Reputation, or goods ill-acquired, will not continue long.", attribution: "Worthington" }
    ] },
    { verse: 10, notes: [
      { text: "Fire. All their grandeur will end in smoke. (Haydock) — Malachias iv. 1., and Matthew xiii. 30.", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Stones. It is broad and easy, Matthew vii.", attribution: "Haydock" }
    ] },
    { verse: 12, notes: [
      { text: "Thereof. Practice makes perfect. A painter may produce a better piece by this means, than one who is more acquainted with theory, (Calmet) and neglects it.", attribution: "Haydock" }
    ] },
    { verse: 15, notes: [
      { text: "Bitterness. True wisdom promotes the general good.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Of life. Which never fails, John iv. 14., and vii. 38.", attribution: "Haydock" }
    ] },
    { verse: 20, notes: [
      { text: "Church. Or assembly, Job xxix. 11, 21. (Calmet) — All good people dislike senseless talk, and approve of what is edifying.", attribution: "Worthington" }
    ] },
    { verse: 21, notes: [
      { text: "Fool. All is in confusion, like a heap of ruins.", attribution: "Haydock" }
    ] },
    { verse: 22, notes: [
      { text: "Hand. He esteems instruction burdensome.", attribution: "Haydock" }
    ] },
    { verse: 23, notes: [
      { text: "Low. A smiling countenance is commendable, but loud laughter is to be avoided. (Clement, P�d. ii. 5.) — It causes too great a change, (Plato, Rep. 3.) and is a mark of folly, Ecclesiastes vii. 5.", attribution: "St. Augustine, contra Acad. ii. 2." }
    ] },
    { verse: 25, notes: [
      { text: "House. And meddles with the concerns of others. (Calmet) — Of the mighty, is not in Greek. The wise will not easily receive invitations.", attribution: "Haydock" }
    ] },
    { verse: 26, notes: [
      { text: "Window. Greek, \"door\" with impudence.", attribution: "Calmet" }
    ] },
    { verse: 29, notes: [
      { text: "Heart. Understanding. (Haydock) — The wise speak with reflection, Proverbs xvi. 23.", attribution: "Haydock" }
    ] },
    { verse: 30, notes: [
      { text: "While the ungodly, &c. He condemneth and curseth himself; inasmuch as by sin he takes part with the devil, and is, as it were, his member and subject. (Challoner) — In vain does he lay the blame of his sins on the devil,", attribution: "Haydock" }
    ] },
    { verse: 31, notes: [
      { text: "By all. Greek, \"in the neighbourhood.\" The rest is omitted.", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
